import { render } from "./ModalExito.vue?vue&type=template&id=2db1f5ac&scoped=true"
import script from "./ModalExito.vue?vue&type=script&lang=js"
export * from "./ModalExito.vue?vue&type=script&lang=js"

import "./ModalExito.vue?vue&type=style&index=0&id=2db1f5ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db1f5ac"]])

export default __exports__